// ErrorBoundary — captura erros de render de uma tela e evita tela branca.
// Exibe mensagem amigável, botão Voltar e mantém o AppShell/menu visível.
// Aceita a prop opcional `message` para customizar o título (ex.: na ficha
// da oportunidade usamos "Não foi possível abrir esta oportunidade").
import React from "react";
import Voltar from "@/components/Voltar";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error("ErrorBoundary:", error, info);
  }
  render() {
    if (this.state.hasError) {
      const message = this.props.message || "Algo deu errado nesta tela";
      return (
        <div className="max-w-4xl" data-testid="error-boundary-fallback">
          <Voltar fallback="/" />
          <div className="mt-4 rounded-lg border border-slate-200 bg-white p-6">
            <h1 className="text-lg font-semibold text-navy">{message}</h1>
            <p className="mt-2 text-sm text-slate-600">
              Tente voltar e abrir novamente. Se o problema continuar, avise o TI.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
